export const SEVERITY_VARS = {
  Critical:        { color: 'var(--severity-critical-text)', bg: 'var(--severity-critical-bg)', key: 'severity.critical'      },
  High:            { color: 'var(--severity-high-text)',     bg: 'var(--severity-high-bg)',     key: 'severity.high'           },
  Medium:          { color: 'var(--severity-medium-text)',   bg: 'var(--severity-medium-bg)',   key: 'severity.medium'         },
  Low:             { color: 'var(--severity-low-text)',      bg: 'var(--severity-low-bg)',      key: 'severity.low'            },
  'Best Practice': { color: 'var(--color-text-body)',       bg: 'var(--color-bg-subtle)',      key: 'severity.best_practice'  },
}
